<div id="summary">
  <div id="summary-sections">
    <div id="top-row">
    <!-- LEFT SIDEBAR: Trip Details actions + Trip Log -->
    <div
      id="left-sidebar"
      class="column"
      [ngClass]="{ tripClosed: trip?.tripStatus === 'Closed' }"
    >
      <div class="section sidebar-actions">
        <h2 class="sidebar-title">Trip Details</h2>

        <div class="sidebar-buttons" *ngIf="trip?.tripStatus !== 'Closed'">
          <ciao-okay-modal-section-v3
            [trip]="trip"
            id="checkout-btns"
            class="btns"
            (checkInEvent)="openCheckpointModal()"
          />
          <button
            id="calendar-btn"
            [disabled]="!canCheckout"
            (click)="onCalendarClick()"
          >
            <svg
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.64315 24.8315C5.02236 24.8315 4.49093 24.6105 4.04886 24.1684C3.60678 23.7263 3.38574 23.1949 3.38574 22.5741V6.77226C3.38574 6.15148 3.60678 5.62004 4.04886 5.17797C4.49093 4.73589 5.02236 4.51485 5.64315 4.51485H6.77185V3.38615C6.77185 3.06635 6.88002 2.79828 7.09636 2.58195C7.31269 2.36561 7.58076 2.25745 7.90056 2.25745C8.22036 2.25745 8.48843 2.36561 8.70476 2.58195C8.9211 2.79828 9.02926 3.06635 9.02926 3.38615V4.51485H18.0589V3.38615C18.0589 3.06635 18.1671 2.79828 18.3834 2.58195C18.5997 2.36561 18.8678 2.25745 19.1876 2.25745C19.5074 2.25745 19.7755 2.36561 19.9918 2.58195C20.2081 2.79828 20.3163 3.06635 20.3163 3.38615V4.51485H21.445C22.0658 4.51485 22.5972 4.73589 23.0393 5.17797C23.4814 5.62004 23.7024 6.15148 23.7024 6.77226V22.5741C23.7024 23.1949 23.4814 23.7263 23.0393 24.1684C22.5972 24.6105 22.0658 24.8315 21.445 24.8315H5.64315ZM5.64315 22.5741H21.445V11.2871H5.64315V22.5741ZM5.64315 9.02967H21.445V6.77226H5.64315V9.02967ZM13.5441 15.8019C13.2243 15.8019 12.9562 15.6937 12.7399 15.4774C12.5235 15.2611 12.4154 14.993 12.4154 14.6732C12.4154 14.3534 12.5235 14.0853 12.7399 13.869C12.9562 13.6527 13.2243 13.5445 13.5441 13.5445C13.8639 13.5445 14.1319 13.6527 14.3483 13.869C14.5646 14.0853 14.6728 14.3534 14.6728 14.6732C14.6728 14.993 14.5646 15.2611 14.3483 15.4774C14.1319 15.6937 13.8639 15.8019 13.5441 15.8019ZM8.22506 15.4774C8.00873 15.2611 7.90056 14.993 7.90056 14.6732C7.90056 14.3534 8.00873 14.0853 8.22506 13.869C8.4414 13.6527 8.70946 13.5445 9.02926 13.5445C9.34906 13.5445 9.61713 13.6527 9.83346 13.869C10.0498 14.0853 10.158 14.3534 10.158 14.6732C10.158 14.993 10.0498 15.2611 9.83346 15.4774C9.61713 15.6937 9.34906 15.8019 9.02926 15.8019C8.70946 15.8019 8.4414 15.6937 8.22506 15.4774ZM18.0589 15.8019C17.7391 15.8019 17.471 15.6937 17.2547 15.4774C17.0384 15.2611 16.9302 14.993 16.9302 14.6732C16.9302 14.3534 17.0384 14.0853 17.2547 13.869C17.471 13.6527 17.7391 13.5445 18.0589 13.5445C18.3787 13.5445 18.6468 13.6527 18.8631 13.869C19.0794 14.0853 19.1876 14.3534 19.1876 14.6732C19.1876 14.993 19.0794 15.2611 18.8631 15.4774C18.6468 15.6937 18.3787 15.8019 18.0589 15.8019ZM13.5441 20.3167C13.2243 20.3167 12.9562 20.2085 12.7399 19.9922C12.5235 19.7759 12.4154 19.5078 12.4154 19.188C12.4154 18.8682 12.5235 18.6001 12.7399 18.3838C12.9562 18.1675 13.2243 18.0593 13.5441 18.0593C13.8639 18.0593 14.1319 18.1675 14.3483 18.3838C14.5646 18.6001 14.6728 18.8682 14.6728 19.188C14.6728 19.5078 14.5646 19.7759 14.3483 19.9922C14.1319 20.2085 13.8639 20.3167 13.5441 20.3167ZM8.22506 19.9922C8.00873 19.7759 7.90056 19.5078 7.90056 19.188C7.90056 18.8682 8.00873 18.6001 8.22506 18.3838C8.4414 18.1675 8.70946 18.0593 9.02926 18.0593C9.34906 18.0593 9.61713 18.1675 9.83346 18.3838C10.0498 18.6001 10.158 18.8682 10.158 19.188C10.158 19.5078 10.0498 19.7759 9.83346 19.9922C9.61713 20.2085 9.34906 20.3167 9.02926 20.3167C8.70946 20.3167 8.4414 20.2085 8.22506 19.9922ZM18.0589 20.3167C17.7391 20.3167 17.471 20.2085 17.2547 19.9922C17.0384 19.7759 16.9302 19.5078 16.9302 19.188C16.9302 18.8682 17.0384 18.6001 17.2547 18.3838C17.471 18.1675 17.7391 18.0593 18.0589 18.0593C18.3787 18.0593 18.6468 18.1675 18.8631 18.3838C19.0794 18.6001 19.1876 18.8682 19.1876 19.188C19.1876 19.5078 19.0794 19.7759 18.8631 19.9922C18.6468 20.2085 18.3787 20.3167 18.0589 20.3167Z"
                fill="currentcolor"
              />
            </svg>

            <span></span>
          </button>
        </div>
      </div>

      <div class="section sidebar-trip-log">
        <div class="trip-log-header">
          <span class="sidebar-title">Trip Log</span>
        </div>
        <div id="trip-log">
          <ciao-trip-log-section-v3 [trip$]="trip$" />
        </div>
      </div>
    </div>

    <!-- RIGHT SIDE: main content -->
    <div
      id="right-side"
      class="column"
      [ngClass]="{ tripClosed: trip?.tripStatus === 'Closed' }"
    >
      <div class="section">
        <div id="details">
          <div class="trip-header">
            <div
              aria-label="trip details header"
              [ngClass]="{ flexStart: dateTimeErrors }"
              class="title header-group title-group"
            >
              <strong class="trip-title"
                >{{ trip?.usergroup?.labelPrefix }}
                {{ trip?.usergroup?.label }}</strong
              >
              <ciao-status-badge
                [status]="trip?.tripStatus"
              ></ciao-status-badge>
            </div>

            <div
              class="header-group dates"
              [ngClass]="{ flexStart: dateTimeErrors }"
            >
              <div class="date-field">
                <span class="date-title" last-char="*">Check Out </span>
                <ciao-form-field
                  class="drab-theme"
                  label="Check out"
                  [agGridContext]="true"
                  type="datetime"
                  [formControlInput]="formGroup.controls.startDate"
                  (blurEvent)="onFieldBlur('startDate', $event)"
                ></ciao-form-field>
              </div>
              <div class="date-field">
                <span class="date-title" last-char="*">Check In </span>
                <ciao-form-field
                  class="drab-theme"
                  label="Check out"
                  [agGridContext]="true"
                  type="datetime"
                  [formControlInput]="formGroup.controls.endDate"
                  (blurEvent)="onFieldBlur('endDate', $event)"
                ></ciao-form-field>
              </div>
            </div>
          </div>
          <div class="trip-header-options">
            <button
              mat-icon-button
              [matMenuTriggerFor]="tripDetailsMenu"
              aria-label="Trip Options"
              class="semantic-button"
            >
              <span class="screenreader">Trip Options</span>
              <mat-icon>more_vert</mat-icon>
            </button>

            <mat-menu #tripDetailsMenu>
              <ng-template matMenuContent let-id="id">
                <button
                  mat-menu-item
                  [routerLink]="['/trip', 'duplicate', trip.id]"
                >
                  <!-- adding inline svg here ( might want to add all these as custom icons at a later point ) -->
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 -5 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.5 19H15C14.7348 19 14.4804 18.8946 14.2929 18.7071C14.1054 18.5196 14 18.2652 14 18C14 17.7348 14.1054 17.4804 14.2929 17.2929C14.4804 17.1054 14.7348 17 15 17H17.5C17.6321 16.9983 17.7583 16.9451 17.8517 16.8517C17.9451 16.7583 17.9983 16.6321 18 16.5V2.5C17.9983 2.36791 17.9451 2.24169 17.8517 2.14828C17.7583 2.05487 17.6321 2.00166 17.5 2H5.5C5.36791 2.00166 5.24169 2.05487 5.14828 2.14828C5.05487 2.24169 5.00166 2.36791 5 2.5V5C5 5.26522 4.89464 5.51957 4.70711 5.70711C4.51957 5.89464 4.26522 6 4 6C3.73478 6 3.48043 5.89464 3.29289 5.70711C3.10536 5.51957 3 5.26522 3 5V2.5C3.0007 1.83717 3.26431 1.20169 3.733 0.733002C4.20169 0.264312 4.83717 0.000696197 5.5 0H17.5C18.1628 0.000696197 18.7983 0.264312 19.267 0.733002C19.7357 1.20169 19.9993 1.83717 20 2.5V16.5C19.9993 17.1628 19.7357 17.7983 19.267 18.267C18.7983 18.7357 18.1628 18.9993 17.5 19Z"
                      fill="currentcolor"
                    />
                    <path
                      d="M13.5 22H2.5C1.83717 21.9993 1.20169 21.7357 0.733002 21.267C0.264312 20.7983 0.000696197 20.1628 0 19.5V6.5C0.000696197 5.83717 0.264312 5.20169 0.733002 4.733C1.20169 4.26431 1.83717 4.0007 2.5 4H13.5C14.1628 4.0007 14.7983 4.26431 15.267 4.733C15.7357 5.20169 15.9993 5.83717 16 6.5V19.5C15.9993 20.1628 15.7357 20.7983 15.267 21.267C14.7983 21.7357 14.1628 21.9993 13.5 22ZM2.5 6C2.36744 6.00017 2.24037 6.05291 2.14664 6.14664C2.05291 6.24037 2.00017 6.36744 2 6.5V19.5C2.00017 19.6326 2.05291 19.7596 2.14664 19.8534C2.24037 19.9471 2.36744 19.9998 2.5 20H13.5C13.6326 19.9998 13.7596 19.9471 13.8534 19.8534C13.9471 19.7596 13.9998 19.6326 14 19.5V6.5C13.9998 6.36744 13.9471 6.24037 13.8534 6.14664C13.7596 6.05291 13.6326 6.00017 13.5 6H2.5Z"
                      fill="currentcolor"
                    />
                  </svg>
                  Duplicate
                </button>
                <button
                  mat-menu-item
                  (click)="deleteTripConfirmModal.openSmallModal()"
                >
                  <mat-icon>delete</mat-icon>
                  Delete
                </button>
                <button
                  mat-menu-item
                  (click)="tripService.addToCalendar(trip)"
                  *ngIf="trip?.tripStatus !== 'Closed'"
                >
                  <mat-icon>event</mat-icon>
                  Add To Calendar
                </button>
                <!-- <a mat-menu-item [routerLink]="['/trip', 'trip-summary-legacy', trip.id]">
                  <mat-icon>filter_2</mat-icon>
                  Trip Summary <br />
                  (old page retained for reference. ciao version 1.x)
                </a> -->
              </ng-template>
            </mat-menu>
          </div>
        </div>
      </div>

      <div class="section">
        <div class="table-header">
          <h3 class="title">Location Details</h3>
        </div>
        <!-- Locations grid table stacked above the map; both span the full
             width of the card. Expanding just gives the map more height. -->
        <div
          class="location-map-row"
          id="tripmap-container"
          [class.map-expanded]="mapExpanded"
        >
          <div class="location-side">
            <ciao-location-grid
              #locationsGrid
              [tripId]="trip?.id"
              [rowData]="trip?.locations"
              [defaultColDef]="defaultColDef"
              [defaultRowSelection]="defaultRowSelection"
              [readOnly]="trip?.tripStatus === 'Closed'"
              (errors)="updateErrorToast('locationsGrid', $event)"
            ></ciao-location-grid>
          </div>
          <div class="map-side">
            <ciao-trip-map
              #tripMap
              class=""
              [trip]="trip$ | async"
              [expanded]="mapExpanded"
              (expandToggle)="toggleMapExpanded()"
              (addLocation)="onMapAddLocation($event)"
            />
          </div>
        </div>
      </div>
    </div>
    </div>

      <ciao-crew-member-grid
        #crewmemberGrid
        [tripId]="trip?.id"
        [rowData]="trip?.crewMembers"
        [defaultRowSelection]="defaultRowSelection"
        [defaultColDef]="defaultColDef"
        [userGroupId]="trip?.userGroupId"
        [readOnly]="trip?.tripStatus === 'Closed'"
        (errors)="updateErrorToast('crewMemberGrid', $event)"
      ></ciao-crew-member-grid>

      <ciao-fleet-vehicle-grid
        #fleetGrid
        [tripId]="trip?.id"
        [rowData]="trip?.equipmentList"
        [defaultColDef]="defaultColDef"
        [defaultRowSelection]="defaultRowSelection"
        [readOnly]="trip?.tripStatus === 'Closed'"
        (errors)="updateErrorToast('fleetGrid', $event)"
      ></ciao-fleet-vehicle-grid>

      <div class="side-by-side-container" [class.schedule-selected]="selectedSchedule !== 'none'">
        <div class="section okay-alerts-section">
          <h3 class="title">Scheduled I'm Okay Alerts</h3>
          <p class="description">
            Scheduled automated I'm Okay reminders during your trip. Select a schedule to generate
            alerts at regular intervals.
          </p>

          <ciao-form-field
            label="Alert Schedule"
            type="combobox"
            [formControlInput]="formGroup.controls.alertSchedule"
            [selectOptions$]="alertScheduleOptions$"
            [storeFullOption]="true"
          ></ciao-form-field>

          <!-- Show checkpoint grid when any schedule (except none) is selected -->
          <div *ngIf="selectedSchedule !== 'none'" class="custom-alerts-container">
            <ciao-checkpoint-grid
              #checkpointsGrid
              [tripId]="trip?.id"
              [defaultColDef]="defaultColDef"
              [defaultRowSelection]="defaultRowSelection"
              [readOnly]="trip?.tripStatus === 'Closed'"
              (checkpointClickEvent)="openCheckpointModal($event)"
              (errors)="updateErrorToast('checkpointsGrid', $event)"
            ></ciao-checkpoint-grid>
          </div>
        </div>

        <div class="section">
          <div class="table-header">
            <h3 id="attachment-table-header" class="title">Attachments</h3>
          </div>
          <ciao-file-upload [trip]="trip$ | async"></ciao-file-upload>
        </div>
      </div>

      <div class="checkout-footer">
        <button
          class="large-button checkout"
          *ngIf="trip?.tripStatus === 'Planned'"
          (click)="canCheckout ? checkOutModal.Open() : null"
          [ngClass]="{ disabled: !canCheckout }"
        >
          <svg
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.64315 23.7029C5.02236 23.7029 4.49093 23.4819 4.04886 23.0398C3.60678 22.5977 3.38574 22.0663 3.38574 21.4455V5.64364C3.38574 5.02285 3.60678 4.49142 4.04886 4.04934C4.49093 3.60727 5.02236 3.38623 5.64315 3.38623H12.4154C12.7352 3.38623 13.0032 3.4944 13.2196 3.71073C13.4359 3.92707 13.5441 4.19514 13.5441 4.51493C13.5441 4.83473 13.4359 5.1028 13.2196 5.31914C13.0032 5.53547 12.7352 5.64364 12.4154 5.64364H5.64315V21.4455H12.4154C12.7352 21.4455 13.0032 21.5537 13.2196 21.77C13.4359 21.9863 13.5441 22.2544 13.5441 22.5742C13.5441 22.894 13.4359 23.1621 13.2196 23.3784C13.0032 23.5947 12.7352 23.7029 12.4154 23.7029H5.64315ZM19.3851 14.6733H11.2867C10.9669 14.6733 10.6988 14.5651 10.4825 14.3488C10.2661 14.1324 10.158 13.8644 10.158 13.5446C10.158 13.2248 10.2661 12.9567 10.4825 12.7404C10.6988 12.524 10.9669 12.4159 11.2867 12.4159H19.3851L17.2688 10.2995C17.0619 10.0926 16.9584 9.83866 16.9584 9.53767C16.9584 9.23668 17.0619 8.97332 17.2688 8.74757C17.4757 8.52183 17.7391 8.40426 18.0589 8.39485C18.3787 8.38545 18.6515 8.49362 18.8772 8.71936L22.9123 12.7545C23.1381 12.9802 23.2509 13.2436 23.2509 13.5446C23.2509 13.8456 23.1381 14.1089 22.9123 14.3347L18.8772 18.3698C18.6515 18.5955 18.3834 18.7037 18.073 18.6943C17.7626 18.6849 17.4945 18.5673 17.2688 18.3416C17.0619 18.1158 16.9631 17.8478 16.9725 17.5374C16.9819 17.227 17.0901 16.9683 17.297 16.7614L19.3851 14.6733Z"
              fill="currentcolor"
            />
          </svg>

          <span>Check Out</span>
        </button>
      </div>
  </div>
</div>
<ciao-scheduled-checkpoint-modal
  #checkPointModal
  [tripId]="tripId"
  *ngIf="tripId"
></ciao-scheduled-checkpoint-modal>

<ciao-okay-modal
  #checkOutModal
  hidden="true"
  [disabled]="!canCheckout"
  okayType="checkOut"
  class="btn"
  [tripSummaryContext]="true"
  buttonClass="btn-action-solid"
  [trip]="trip"
></ciao-okay-modal>

<!-- Delete Trip Modal -->
<ciao-modal #deleteTripConfirmModal title="Confirm Delete Trip?">
  <span modalBody>
    <div class="container">
      <div class="row">
        <h5>Are you sure you want to delete this trip?</h5>
      </div>
    </div>
  </span>
  <span modalFooter>
    <div class="justify-content-center d-flex">
      <button
        class="btn-action-light center"
        (click)="deleteTripConfirmModal.close('')"
      >
        Cancel
      </button>

      <button class="btn-action-solid center" (click)="deleteTrip($event)">
        Delete Trip
      </button>
    </div>
  </span>
</ciao-modal>
